import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { adminApi, apiError } from '../../lib/adminApi';
import { CalendarClock, X } from 'lucide-react';

const toLocalInput = (iso) => {
  const d = new Date(iso);
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Athens', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
    .formatToParts(d).map((p) => [p.type, p.value]));
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export default function SchedulePicker({ post, reload }) {
  const [val, setVal] = useState(post.scheduled_at ? toLocalInput(post.scheduled_at) : '');
  useEffect(() => { setVal(post.scheduled_at ? toLocalInput(post.scheduled_at) : ''); }, [post.scheduled_at]);

  const save = async () => {
    if (!val) return;
    try {
      await adminApi.put(`/admin/social/posts/${post.id}/schedule`, { scheduled_at: val, targets: ['instagram', 'facebook'] });
      toast.success('Post programmato');
      reload();
    } catch (e) { toast.error(apiError(e)); }
  };
  const clear = async () => { await adminApi.delete(`/admin/social/posts/${post.id}/schedule`); setVal(''); reload(); };

  return (
    <div className="flex items-center gap-2" data-testid="schedule-picker">
      <input type="datetime-local" value={val} onChange={(e) => setVal(e.target.value)} data-testid="schedule-input"
        className="flex-1 min-w-0 bg-black border border-white/15 rounded-lg px-2 py-1.5 text-white text-xs outline-none focus:border-red-500 [color-scheme:dark]" />
      <button onClick={save} data-testid="schedule-save-btn" title="Programma"
        className="p-2 rounded-lg bg-red-600 hover:bg-red-500 text-white transition-colors"><CalendarClock size={14} /></button>
      {post.scheduled_at && (
        <button onClick={clear} data-testid="schedule-clear-btn" title="Annulla programmazione"
          className="p-2 rounded-lg border border-white/15 text-white/70 hover:text-white"><X size={14} /></button>
      )}
    </div>
  );
}
